import { render, staticRenderFns } from "./PdfAddendaProducer.vue?vue&type=template&id=c9f9f3f2&scoped=true"
import script from "./PdfAddendaProducer.vue?vue&type=script&lang=js"
export * from "./PdfAddendaProducer.vue?vue&type=script&lang=js"
import style0 from "./PdfAddendaProducer.vue?vue&type=style&index=0&id=c9f9f3f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f9f3f2",
  null
  
)

export default component.exports